/**
 * Причины логаута `HeaderLogoutButtonClick`, `UserInactivity`, `AlertPageLogoutButtonClick` должны использоваться только в newclick-host-ui
 */
export function logout(reason) {
    if (typeof window !== 'undefined') {
        window?.logout(reason);
    }
}
